import React, { useEffect, useState } from 'react'
import Common_Images_Transport from '../../common/common_imges_transport/Common_Images_Transport'
import Header from '../../common/header/Header'
import Footer from '../../common/footer/Footer'
import Download_app from '../../../assets/img/app-download/app.png'
import { fetchSettingData } from '../../../redux/actions/settingAction'
import { useDispatch, useSelector } from 'react-redux'

const Download_App = () => {
    const dispatch = useDispatch();
    const { settingData } = useSelector(
        (state) => state?.settingdata || []
    );

    useEffect(() => {
        dispatch(fetchSettingData());
    }, [dispatch]);

    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])
    return (
        <div>
            {/*  */}
            <Header />
            <div className="flex gap-6 items-center justify-center bg-white text-center py-10">
                {/* Phone Image */}
                <div className="relative mb-6">
                    <div className="w-lg flex items-center justify-center shadow-lg">
                        <img src={Download_app} alt="Astrotalk" className="w-56" />
                    </div>
                </div>

                {/* Text */}
                <div className='mb-4'>
                    <h2 className="text-lg font-semibold text-gray-800">
                        To use this feature please,
                    </h2>
                    <h3 className="text-xl font-bold text-gray-900">
                        Download Our Mobile App
                    </h3>

                    {/* App Store & Google Play Buttons */}
                    <div className="mt-4 flex gap-4">
                        <a
                            href={`${settingData && settingData[0]?.app_store}`}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <img
                                src={Common_Images_Transport?.apple}
                                alt="Download on the App Store"
                                className="w-40 h-12"
                            />
                        </a>
                        <a
                            href={`${settingData && settingData[0]?.play_store}`}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <img
                                src={Common_Images_Transport?.android}
                                alt="Get it on Google Play"
                                className="w-40 h-12"
                            />
                        </a>
                    </div>
                </div>
            </div>
            {/*  */}
            <Footer />
        </div>

    )
}

export default Download_App
